import { DeepWritable } from 'ts-essentials';

import { api } from 'app/app.api';

import {
  CreateWebformEndpointApiArg,
  CreateWebformEndpointApiResponse,
  DeleteWebformEndpointApiArg,
  DeleteWebformEndpointApiResponse,
  ReadWebformEndpointsApiResponse,
} from './types/webformEndpointsApi';

export const webformEndpointsApi = api
  .enhanceEndpoints({
    addTagTypes: ['WebformEndpoint'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      readWebformEndpoints: builder.query<
        ReadWebformEndpointsApiResponse,
        void
      >({
        query: () => ({
          version: 1,
          path: 'webform-endpoints',
        }),
        providesTags: (result, _error, _arg) =>
          result
            ? [
                ...result.data.endpoints.map(({ id }) => ({
                  type: 'WebformEndpoint' as const,
                  id,
                })),
                'WebformEndpoint',
              ]
            : ['WebformEndpoint'],
      }),
      createWebformEndpoint: builder.mutation<
        CreateWebformEndpointApiResponse,
        CreateWebformEndpointApiArg
      >({
        query: (body) => ({
          version: 1,
          method: 'POST',
          path: 'webform-endpoints',
          body,
        }),
        async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
          const response = await queryFulfilled;

          dispatch(
            webformEndpointsApi.util.updateQueryData(
              'readWebformEndpoints',
              undefined,
              (draft) => {
                const endpoints = draft.data.endpoints as DeepWritable<
                  typeof draft.data.endpoints
                >;
                endpoints.push(response.data.data);
                endpoints.sort((a, b) => a.id.localeCompare(b.id));
              },
            ),
          );
        },
      }),
      deleteWebformEndpoint: builder.mutation<
        DeleteWebformEndpointApiResponse,
        DeleteWebformEndpointApiArg
      >({
        query: ({ webformId }) => ({
          version: 1,
          method: 'DELETE',
          path: `webform-endpoints/${webformId}`,
        }),
        async onQueryStarted({ webformId }, { dispatch, queryFulfilled }) {
          const patchResult = dispatch(
            webformEndpointsApi.util.updateQueryData(
              'readWebformEndpoints',
              undefined,
              (draft) => {
                const endpoints = draft.data.endpoints as DeepWritable<
                  typeof draft.data.endpoints
                >;
                endpoints.splice(
                  endpoints.findIndex(({ id }) => id === webformId),
                  1,
                );
              },
            ),
          );

          try {
            await queryFulfilled;
          } catch {
            patchResult.undo();
          }
        },
      }),
    }),
  });
